import * as HELPER from "../../../src/config/helper";
import { useLanguage } from "../../../src/context/LanguageContext";
import { useState,useEffect } from "react";
import FullPageLoader from '@src/common/FullPageLoader';
import ConfirmPopup from '../../../src/common/ConfirmPopUp';
import { useParams } from "react-router-dom";
import {REMITTANCE_TYPE,LEAD_ASSIGN_TO,ADMIN_OPS_STATUS,ADMIN_MAKER_STATUS,ADMIN_CHECKER_STATUS,ADMIN_CHECKER_COMPLETE_STATUS} from '../../../src/config/constant';
import { saveRemittanceDetails } from '../../../src/store/slices/remittance';
import PaymentInfo from "./PaymentInfoCard";

const DealerRemittance = (props: any) => {
  const { id,type } = useParams<{ id: string,type:string }>()
  const { translations } = useLanguage();
  const [remittanceDetail , setRemittanceDetail] = useState<any>({});
  const [loading, setLoading] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState<string>(translations.Remittance?.["SAVE_DETAIL_CONFIRMATION"]);
  const [confirmationFrom, setConfirmationFrom] = useState<string>("InsurerPartnerRemittance")
  const [LeadAssignTo, setLeadAssignTo] = useState<string>("");
  const [remittanceType, setRemittanceType] = useState<string>("");
  const [leadRemark, setLeadRemark] = useState<string>("");

  useEffect(() => {
    if (Array.isArray(props.remittanceDetails) && props.remittanceDetails.length > 0) {
      const referralRemittance = props.remittanceDetails.find((b: any) => b.remittance_type_name === REMITTANCE_TYPE['referral']);
      setRemittanceType(REMITTANCE_TYPE['referral']);
      setRemittanceDetail(referralRemittance);
      props.setSelectedFilters((prev:any) => ({
        ...prev,
        referral_remittance: referralRemittance?.referral_remmitted_already
      }));
    }
      // eslint-disable-next-line
  },[props.remittanceDetails])

  /**
   * Validate Partner Form
   * @returns 
   */
  const validateForm = () => {
    const newErrors: any = {};
    // Example validations
    if (!props.selectedFilters?.referral_remittance) {
      newErrors.referral_remittance = "Referral Remmitted Already is required";
    }
    props.setErrors(newErrors);
    // return true only if no errors
    return Object.keys(newErrors).length === 0;
  };

  const saveDetail = async () => {
    try{
       setLoading(true);
      const payload = {
        lead_id : id,
        referral_remittance : String(props.selectedFilters?.referral_remittance),
        type : REMITTANCE_TYPE['referral'],
        ...((props.isCheckerLoggedIn || ADMIN_CHECKER_STATUS.includes(remittanceDetail?.remittance_status)) && { mark_payment_complete: true }),
        ...((props.isCheckerLoggedIn || ADMIN_CHECKER_STATUS.includes(remittanceDetail?.remittance_status)) && { remarks: leadRemark })
      };
      const response:any = await saveRemittanceDetails(payload);
      if (response?.status === 200) {
        props.setCallReloadApi(props.callReloadApi+1);
        props.setFormReferralChangeDetect(false);
        setShowConfirmation(false);
      }
    }catch (error) {
      console.error("Error while save Remittance Partner Detail:", error);
    }finally {
      setLoading(false);
    }
  }

  const askTosaveDetail = () => {
    try{
      if(props.isMakerLoggedIn || (props.isAdminLoggedIn && ADMIN_MAKER_STATUS.includes(remittanceDetail?.remittance_status))){
        setConfirmationMessage(translations.Remittance?.["SEND_TO_OPS_CONFIRMATION"]);
        setConfirmationFrom("SendToMaker");
        setLeadAssignTo(LEAD_ASSIGN_TO['REM_OPS']);
        setShowConfirmation(true);
      }else if (props.isCheckerLoggedIn || (props.isAdminLoggedIn && ADMIN_CHECKER_STATUS.includes(remittanceDetail?.remittance_status))) {
        setConfirmationMessage(translations.Remittance?.["SEND_TO_MAKER_CONFIRMATION"]);
        setConfirmationFrom("SendToMaker");
        setLeadAssignTo(LEAD_ASSIGN_TO['REM_FINANCE_MAKER']);
        setShowConfirmation(true);
      }else{
        if(props.isOpsLoggedIn || (props.isAdminLoggedIn && ADMIN_OPS_STATUS.includes(remittanceDetail?.remittance_status))){
          if(props.formReferralChangeDetect){
            const isFormValid = validateForm();
            if(isFormValid){
              props.setErrors({});
              setConfirmationMessage(translations.Remittance?.["SAVE_DETAIL_CONFIRMATION"]);
              setConfirmationFrom("SaveDetail");
              setLeadAssignTo("");
              setShowConfirmation(true);
            }
          }else{
            setConfirmationMessage(translations.Remittance?.["SEND_TO_MAKER_CONFIRMATION"]);
            setConfirmationFrom("SendToMaker");
            setLeadAssignTo(LEAD_ASSIGN_TO['REM_FINANCE_MAKER']);
            setShowConfirmation(true);
          }
        }
      }
    }catch (error) {
        console.error("Error while updating remittance detail:", error);
    }
  }

  const reloadDetail = async () => {
    props.setCallReloadApi(props.callReloadApi+1);
  }

  const markPaymentComplete = () => {
    setConfirmationMessage(translations.Remittance?.["COMPLETE_PAYMENT_CONFIRMATION"]);
    setConfirmationFrom("InsurerPartnerRemittance");
    setLeadAssignTo("");
    setShowConfirmation(true);
  }

  const cancelFormChange = async () => {
    props.setFormReferralChangeDetect(false);
    props.setCallReloadApi(props.callReloadApi+1);
  }

  const validTypes = Object.values(REMITTANCE_TYPE);
  const currentType = validTypes.includes(type) ? type : null;
  const isReferralDisabled = currentType !== REMITTANCE_TYPE.referral;

  return (
    <>
      <FullPageLoader show={loading} />
      {
        showConfirmation && 
        <ConfirmPopup
            confirmNo={() => setShowConfirmation(false)}
            confirmYes={saveDetail}
            message={confirmationMessage}
            isConfirmNotVisible={true} 
            from={confirmationFrom}
            LeadAssignTo={LeadAssignTo}
            remittanceType={remittanceType}
            reloadDetail={reloadDetail}
            setLeadRemark={setLeadRemark}>
        </ConfirmPopup>
      }
      {/* Dealer Remittance */}
      <div className={`remittance-card`}>
        {
          isReferralDisabled &&
          <div className="card-dissable"></div>
        }
        <div className="remittance-header">
          <h2>{translations.Remittance?.["REFERRAL_FEE_REMITTANCE"] || translations.commonMsg?.loading}</h2>
        </div>

        <div className="remittance-table dealer-agency">
          <div className="remittance-row">
            <span className="remittance-row-heading">{translations.Remittance?.["REFERRAL_PAYOUT_ACTUAL"] || translations.commonMsg?.loading}</span>
            <span className="value">{`${HELPER.addCurrencyFormatting(Number(remittanceDetail?.referral_payout_Actual).toFixed(2))}`}</span>
          </div>
          <div className="remittance-row">
            <span className="remittance-row-heading">{translations.Remittance?.["FINAL_REMITTANCE_TO_DEALER"] || translations.commonMsg?.loading}</span>
             <span className="highlight-blue">
              {HELPER.addCurrencyFormatting(
                (
                  Number(remittanceDetail?.referral_payout_Actual || 0) -
                  Number(remittanceDetail?.referral_remmitted_already || 0)
                ).toFixed(2)
              )}
            </span>
          </div>
          <div className="remittance-row">
            <span className="remittance-row-heading">{translations.Remittance?.["REFERRAL_REMITTED_ALREADY"] || translations.commonMsg?.loading}</span>
            <input
              type="text"
              value={
                (
                  // OPS can edit
                  (props.isOpsLoggedIn &&
                    props.roleStatus?.includes(remittanceDetail?.remittance_status) &&
                    +remittanceDetail?.ops_id === +props.currentLoggedInUser)
                  ||
                  // ADMIN can edit (status 1 or 2, no roleStatus check)
                  (props.isAdminLoggedIn &&
                    ADMIN_OPS_STATUS.includes(remittanceDetail?.remittance_status))
                )
                  ? props.selectedFilters?.referral_remittance || ""
                  : HELPER.addCurrencyFormatting(props.selectedFilters?.referral_remittance || 0)
              }
              className={
                !props.isOpsLoggedIn && !props.isAdminLoggedIn
                  ? "inputui input-bg-colur"
                  : (
                      // OPS condition
                      (props.isOpsLoggedIn &&
                        props.roleStatus?.includes(remittanceDetail?.remittance_status) &&
                        +remittanceDetail?.ops_id === +props.currentLoggedInUser)
                      ||
                      // ADMIN condition (no roleStatus check)
                      (props.isAdminLoggedIn &&
                        ADMIN_OPS_STATUS.includes(remittanceDetail?.remittance_status))
                    )
                  ? "inputui"
                  : "inputui input-bg-colur"
              }
              onChange={(e) => props.handleChange(e.target.value, "referral_remittance")}
              readOnly={
                !(
                  (props.isOpsLoggedIn &&
                    props.roleStatus?.includes(remittanceDetail?.remittance_status) &&
                    +remittanceDetail?.ops_id === +props.currentLoggedInUser)
                  ||
                  (props.isAdminLoggedIn &&
                    ADMIN_OPS_STATUS.includes(remittanceDetail?.remittance_status))
                )
              }
            />

          </div>
           {props.errors?.referral_remittance && (
              <small className="error">{props.errors?.referral_remittance}</small>
            )}
        </div>
        {
          ((remittanceDetail?.payment && props.isCheckerLoggedIn && +remittanceDetail?.checker_id === +props.currentLoggedInUser) || (remittanceDetail?.payment && props.isAdminLoggedIn && ADMIN_CHECKER_COMPLETE_STATUS.includes(remittanceDetail?.remittance_status))) &&
          <PaymentInfo remittanceDetail={remittanceDetail}></PaymentInfo>
        }
        {
          currentType === REMITTANCE_TYPE.referral && 
          <>
            {
              props.isOpsLoggedIn && props.roleStatus?.includes(remittanceDetail?.remittance_status) && +remittanceDetail?.ops_id === +props.currentLoggedInUser &&
              <>
                <button className={`save-btn ${props.formReferralChangeDetect ? "backtoopsbutoon" : ""}`} onClick={askTosaveDetail}>{translations.Remittance?.[!props.formReferralChangeDetect ? "SEND_TO_MAKER" : "SAVE_DETAILS"] || translations.commonMsg?.loading}</button>
                {props.formReferralChangeDetect && (
                  <button className="cancle-btn" onClick={cancelFormChange}>{translations.Remittance?.CANCEL || "Cancel"}</button>
                )}
              </>
            }
            {
              props.isMakerLoggedIn && props.roleStatus?.includes(remittanceDetail?.remittance_status) && +remittanceDetail?.maker_id === +props.currentLoggedInUser &&
                <div>
                  <button className="save-btn backtoopsbutoon" onClick={askTosaveDetail}>{translations.Remittance?.["BACK_TO_OPS"] || translations.commonMsg?.loading}</button>
                  <button className="save-btn" onClick={() => props.makePayment(remittanceType)}>{translations.Remittance?.["MAKE_PAYMENT"] || translations.commonMsg?.loading}</button>
                </div>
            }
            {
              props.isCheckerLoggedIn && props.roleStatus?.includes(remittanceDetail?.remittance_status) && +remittanceDetail?.checker_id === +props.currentLoggedInUser &&
              <div>
                <button className="save-btn backtoopsbutoon" onClick={askTosaveDetail}>{translations.Remittance?.["BACK_TO_MAKER"] || translations.commonMsg?.loading}</button>
                <button className="save-btn" onClick={markPaymentComplete}>{translations.Remittance?.["MARK_AS_COMPLETE"] || translations.commonMsg?.loading}</button>
              </div>
            }
            {/* ============================== */}
            {/* ADMIN-ONLY BUTTON CONDITIONS */}
            {/* ============================== */}
            {/* Admin sees OPS button when status is 1 or 2 */}
            {
              props.isAdminLoggedIn && ADMIN_OPS_STATUS.includes(remittanceDetail?.remittance_status) && (
                <>
                  <button className={`save-btn ${props.formReferralChangeDetect ? "backtoopsbutoon" : ""}`} onClick={askTosaveDetail}>
                    {translations.Remittance?.[!props.formReferralChangeDetect ? "SEND_TO_MAKER" : "SAVE_DETAILS"] || translations.commonMsg?.loading}
                  </button>
                  {props.formReferralChangeDetect && (
                    <button className="cancle-btn" onClick={cancelFormChange}>{translations.Remittance?.CANCEL || "Cancel"}</button>
                  )}
                </>
              )
            }
            {/* Admin sees MAKER buttons when status is 3 or 4 */}
            {
              props.isAdminLoggedIn && ADMIN_MAKER_STATUS.includes(remittanceDetail?.remittance_status) && (
                <div>
                  <button className="save-btn backtoopsbutoon" onClick={askTosaveDetail}>
                    {translations.Remittance?.["BACK_TO_OPS"] || translations.commonMsg?.loading}
                  </button>
                  <button className="save-btn" onClick={() => props.makePayment(remittanceType)}>
                    {translations.Remittance?.["MAKE_PAYMENT"] || translations.commonMsg?.loading}
                  </button>
                </div>
              )
            }
            {/* Admin sees CHECKER buttons when status is 5 */}
            {
              props.isAdminLoggedIn && ADMIN_CHECKER_STATUS.includes(remittanceDetail?.remittance_status) && (
                <div>
                  <button className="save-btn backtoopsbutoon" onClick={askTosaveDetail}>
                    {translations.Remittance?.["BACK_TO_MAKER"] || translations.commonMsg?.loading}
                  </button>
                  <button className="save-btn" onClick={markPaymentComplete}>
                    {translations.Remittance?.["MARK_AS_COMPLETE"] || translations.commonMsg?.loading}
                  </button>
                </div>
              )
            }
          </>
        }
      </div>
    </>
  );
};

export default DealerRemittance;
